const sortCategories = items => {
  const defaultItems = items
    .filter(item => item.default_value === true)
    .sort((a, b) => a.income_heads_id - b.income_heads_id);

  const titleCount = {};

  defaultItems.forEach(item => {
    const title = item._income_heads.title;

    if (titleCount[title]) {
      titleCount[title]++;
      item._income_heads.title = `${title} ${titleCount[title]}`;
    } else {
      titleCount[title] = 1;
    }
  });

  const customItems = items.filter(item => item.custom_value === true);

  const otherItems = items.filter(
    item => !item.default_value && !item.custom_value
  );

  return [...defaultItems, ...customItems, ...otherItems];
};

export default sortCategories;
